import { Component } from '@angular/core'
import { FieldType } from '@ngx-formly/core'

@Component({
  selector: 'basin-formly-timepicker',
  templateUrl: './formly-timepicker.component.html',
  styleUrls: [],
})
export class FormlyTimepickerComponent extends FieldType {}
